module.exports = __webpack_public_path__ + "img/house_quote.90ccf5cf.png";